/** Clé site depuis le build Vue ou la meta index.html */
export function readRuntimeTurnstileSiteKey() {
  if (typeof window === 'undefined') return '';
  try {
    const g = window.__TURNSTILE_SITE_KEY__;
    if (g != null && String(g).trim()) return String(g).trim();
    const el = document.querySelector('meta[name="turnstile-site-key"]');
    const c = el && el.getAttribute('content');
    if (c != null && String(c).trim()) return String(c).trim();
  } catch (_) {}
  return '';
}

export function readBuildTurnstileSiteKey() {
  return String(process.env.VUE_APP_TURNSTILE_SITE_KEY || '').trim();
}

/** Résout la clé site : build → meta (pas d'appel API). */
export function resolveTurnstileSiteKey() {
  return readBuildTurnstileSiteKey() || readRuntimeTurnstileSiteKey();
}

export function loadTurnstileScript() {
  return new Promise((resolve, reject) => {
    if (typeof document === 'undefined') return resolve();
    if (window.turnstile) return resolve();
    const existing = document.querySelector('script[data-turnstile="1"]');
    if (existing) {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('turnstile_load_failed')), { once: true });
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.defer = true;
    s.dataset.turnstile = '1';
    s.addEventListener('load', () => resolve(), { once: true });
    s.addEventListener('error', () => reject(new Error('turnstile_load_failed')), { once: true });
    document.head.appendChild(s);
  });
}

export async function mountTurnstileWidget(containerEl, siteKey, callbacks = {}) {
  if (!containerEl || !siteKey) return null;
  await loadTurnstileScript();
  if (!window.turnstile) throw new Error('turnstile_unavailable');
  const { onSuccess, onError, onExpired, size, theme } = callbacks;
  return window.turnstile.render(containerEl, {
    sitekey: siteKey,
    ...(size ? { size } : {}),
    ...(theme ? { theme } : {}),
    callback: (token) => { onSuccess?.(token || ''); },
    'error-callback': () => { onError?.(); },
    'expired-callback': () => { onExpired?.(); },
  });
}

export function resetTurnstileWidget(widgetId, onClear) {
  if (typeof window !== 'undefined' && window.turnstile && widgetId != null) {
    try { window.turnstile.reset(widgetId); } catch (_) {}
  }
  onClear?.();
}
